let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3hppq")).then(() => parcelRequire('4Wl86'));